// auth
export const LOGOUT = 'AUTH/LOGOUT';

// organizations
export const SET_CURRENT_ORGANIZATION = 'ORGANIZATIONS/SET_CURRENT';
export const ADD_MEMBER = 'ORGANIZATIONS/ADD_MEMBER';
export const REMOVE_MEMBER = 'ORGANIZATIONS/REMOVE_MEMBER';

// editor actions
export const EDITOR_FOCUS_PANEL = 'EDITOR/FOCUS_PANEL';
export const EDITOR_SET_LOADING_SCENE = 'EDITOR/SET_LOADING_SCENE';
export const EDITOR_SET_SCENE_LOADED = 'EDITOR/SET_SCENE_LOADED';

// projects

export const PROJECTS_SELECT_ITEMS = 'PROJECTS/SELECT_ITEMS';
export const PROJECTS_TOGGLE_BATCH_EDIT = 'PROJECTS/PROJECTS_TOGGLE_BATCH_EDIT';
export const PROJECTS_ADD = 'PROJECTS/ADD';
export const PROJECT_DESELECT_ALL = 'PROJECTS/DESELECT_ALL';

// map
export const MAP_ADD_PORTAL_REQUEST = 'MAP/ADD_PORTAL_REQUEST';
export const MAP_ADD_PORTAL_RESPONSE = 'MAP/ADD_PORTAL_RESPONSE';
export const MAP_SELECT_WIDGET = 'MAP/SELECT_WIDGET';
export const MAP_UPDATE_WIDGET_REQUEST = 'MAP/UPDATE_WIDGET_REQUEST';
export const MAP_UPDATE_WIDGET_RESPONSE = 'MAP/UPDATE_WIDGET_RESPONSE';

export const MAP_ADD_CONNECTOR_REQUEST = 'MAP/ADD_CONNECTOR_REQUEST';
export const MAP_ADD_CONNECTOR_RESPONSE = 'MAP/ADD_CONNECTOR_RESPONSE';
export const MAP_UPDATE_CONNECTOR = 'MAP/UPDATE_CONNECTOR';
export const MAP_REMOVE_CONNECTOR_LOCAL = 'MAP/REMOVE_CONNECTOR_LOCAL';
export const MAP_REMOVE_CONNECTOR = 'MAP/REMOVE_CONNECTOR';
export const MAP_REMOVE_WIDGET = 'MAP/REMOVE_WIDGET';
export const MAP_REMOVE_WIDGET_LOCAL = 'MAP/REMOVE_WIDGET_LOCAL';
export const MAP_REMOVE_WIDGET_SUCCESS = 'MAP/REMOVE_WIDGET_SUCCESS';

export const MAP_UPDATE_REQUEST = 'MAP/UPDATE_REQUEST';
export const MAP_UPDATE_RESPONSE = 'MAP/UPDATE_RESPONSE';
export const MAP_LOAD = 'MAP/LOAD';

// history of changes
export const HISTORY_ADD_RECORD = 'HISTORY/ADD_RECORD';

// inspector
export const INSPECTOR_SELECT_ITEM = 'INSPECTOR/SELECT_ITEM';



// WEBPACK FOOTER //
// ./src/redux/actions/actionTypes.js